import { createPermission } from '@backstage/plugin-permission-common';

/**
 * Every route of the plugin checks this, GET included: key names and vault
 * metadata are admin-only too. The backend also requires membership in a
 * group pinned in config, so granting this from the RBAC UI alone is not
 * enough.
 */
export const keyvaultSecretWritePermission = createPermission({
  name: 'keyvault.secret.write',
  attributes: { action: 'update' },
});

export const keyvaultSecretsPermissions = [keyvaultSecretWritePermission];
